import { UsersSeries } from '../../../models/analytics/analytics.model';
import { useGet } from '../../useApi';

// GET /admin/analytics/users?year= (by month) or ?month=YYYY-MM (by day).
const useUsersAnalytics = () => {
  const { data, loading, fetch } = useGet<UsersSeries>('Failed to load user growth');
  return {
    users: data,
    loading,
    fetchYear: (year: number) => fetch('api/v1/admin/analytics/users', { year }),
    fetchMonth: (month: string) => fetch('api/v1/admin/analytics/users', { month }),
  };
};

export default useUsersAnalytics;
